<template>
  <div class="pt-2 manageshipment__wrapper2">
    <div class="text-center" v-if="isLoading || isLoadingGetFilterShipment">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div class="_global__nodata d-flex justify-content-center align-items-center"
      v-else-if="shipmentList.length === 0 && selectedtabs === 'ongoing'">
        <div class="text-center">
          <img src="@/assets/image/icon/nodata-ongoing.svg" alt="">
          <h4 class="pt-3">Currently you don’t have any on going shipment</h4>
        </div>
    </div>
    <div class="_global__nodata d-flex justify-content-center align-items-center"
    v-else-if="shipmentList.length === 0 && selectedtabs !== 'ongoing'">
        <div class="text-center">
          <img src="@/assets/image/icon/nodata-older.svg" alt="">
          <h4 class="pt-3">No archive found</h4>
        </div>
    </div>
    <div v-else>
      <div class="shipment__ocean row m-0 mb-2"
      :class="selectedtabs !== 'failed' ? 'shipmentongoing' : 'shipmentolder'"
      v-for="(item, i) in shipmentList" :key="i">
        <div class="col1" style="min-width: 260px;"
            :class="selectedtabs === 'completed' ? 'bc_green' : item.freightMode === 'OCEAN' ? 'bc_blue' : item.freightMode === 'LAND' ? 'bc_deepgreen' : ''">
          <div class="row m-0 h-100">
            <img :src="getImageShipment(item.freightMode)" alt="" width="35" height="67">
            <div class="col-md pr-0 d-flex flex-column justify-content-center">
              <p class="created_at">{{getDate(item.createdAt)}}</p>
              <p class="shipment_type">{{getType(item.statusShipment)}}</p>
              <p class="ref_number">{{item.referenceNumber}}</p>
            </div>
          </div>
        </div>
        <div 
          class="col-md col2"
          :class="selectedtabs === 'completed' ? 'color_green' : item.freightMode === 'OCEAN' ? 'color_blue' : item.freightMode === 'LAND' ? 'color_deepgreen' : ''">
          <div class="row m-0 h-100 w-100">
            <div class="col-md-5 col2-1 d-flex flex-column justify-content-center">
              <div class="col2-1_content mb-2">
                <div class="w-100">
                  <!-- <p class="compname pb-1">{{item.shipperCompany}}</p> -->
                  <div class="row m-0 salesname">
                    <p class="p-0 pr-1">PO Number</p>
                    <p>:</p>
                    <p class="col-md p-0 pl-1">{{mixinConvertSymbol(item.poNumber, '&') || '-'}}</p>
                  </div>
                </div>
              </div>
              <div class="see__detail" :class="selectedtabs === 'completed' ? 'd-flex align-items-center' : ''">
                <router-link tag="a" class="text-center button__bluesmall mr-2"
                :class="selectedtabs === 'completed' ? 'bc_green' : item.freightMode === 'OCEAN' ? 'bc_blue' : item.freightMode === 'LAND' ? 'bc_deepgreen' : 'bc_purple'"
                :to="{name: 'ManagementShipmentDetail', params: {type: selectedtabs, id_shipment: item.shipmentId, order_number: item.orderNumber.split('/').join('-') }}">
                  See Details
                </router-link>
                <button
                  v-if="item.fiataStatus && item.fiataStatus.length > 0"
                  class="button__bluesmall"
                  :class="selectedtabs === 'completed' ? 'bc_green' : item.freightMode === 'OCEAN' ? 'bc_blue' : 'bc_purple'"
                  @click="openModalDownloadFbl(item)">Download FBL</button>
                <div v-if="selectedtabs === 'completed'" class="ml-2">
                  <button v-if="item.rate === 'Rate Us'" class="button__bluesmall bc_green_white d-flex align-items-center justify-content-center" @click="feedBack(item)">
                    Give feedback
                    <div class="ml-2" style="width: 7px;height: 7px;border-radius: 100%;background-color: red;"></div>
                  </button>
                  <button v-else class="button__bluesmall bc_green_white" @click="feedBackView(item)">View feedback</button>
                </div>
              </div>
            </div>
            <div class="col-md-5 col2-2 d-flex flex-column justify-content-center border-grey" style="row-gap: 8px;">
              <p class="ordernumber">{{item.orderNumber}}</p>
              <b class="route">{{ item.originCity }} ({{ item.originCountryCode }}) to
                {{ item.destinationCity }} ({{ item.destinationCountryCode }})</b>
              <p v-if="item.freightMode !== 'LAND'" class="freight">
                {{getShipmentType(item.freightType.replace(/SEA/g,''))}} -
                {{getOptionTp(item.shipmentService)}}</p>
            </div>
            <div class="col-md-2 text-center col2-3 border-grey" style="place-self: center;">
              <img :src="getImageCanceledRejected(item.orderStat)"
              :class="{'img__canceled' : item.orderStat === 'REJECTED' ||
              item.orderStat === 'CANCELLED'}" alt="">
              <img class="pb-1 img__otif" :src="getImageOtif(item.orderStat, item.freightMode)" 
              :style="selectedtabs === 'completed' ? getOtifColor('green') : 
              item.freightMode === 'LAND' ? getOtifColor('deepgreen') : 
              item.freightMode === 'AIR' ? getOtifColor('purple') : 
              getOtifColor('blue')" alt="image-otif">
              <p class="status_otif">{{item.orderStat.split('_').join(' ').replace(/OTIF/g,'') |
                capitalize}}</p>
              <div class="status_otif mt-2" v-if="item.orderStatNote">
                <p class="font-weight-bold">{{item.orderStatNote}}</p>
                <p class="mt-1" v-if="item.updatedAt">{{getDateDefauld(item.updatedAt)}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1 p-0 col3">
          <div class="bg_top" :class="{'bc_blue' : item.freightMode === 'OCEAN', 'bc_deepgreen' : item.freightMode === 'LAND' }"
          :style="getProgress(item.percentage, 'top')"></div>
          <div class="bg_bottom" :class="selectedtabs === 'completed' ? 'bc_green' : item.freightMode === 'OCEAN' ? 'bc_blue' : item.freightMode === 'LAND' ? 'bc_deepgreen' : ''"
          :style="getProgress(item.percentage, 'bottom')"></div>
          <div class="progress" :class="selectedtabs === 'completed' ? 'color_green' : item.freightMode === 'OCEAN' ? 'color_blue' : item.freightMode === 'LAND' ? 'color_deepgreen' : ''">
            <p>{{item.percentage}}%</p>
          </div>
        </div>
      </div>
    </div>
    <DownloadFbl :fiataStatus="selectedShipment.fiataStatus" :orderNumber="selectedShipment.orderNumber" />
  </div>
</template>

<script>
import mixin from '@/mixin/manage-shipment/tab_list'
import mixinDateTime from '@/mixin/getters/date-time'
import mixinFunctions from '@/mixin/getters/functions'
import mixinShipment from '@/mixin/getters/shipment-details'
import DownloadFbl from '../global/modals/DownloadFbl.vue'

export default {
  components: { DownloadFbl },
  name: 'ManagementShipmentList',
  mixins: [mixin, mixinDateTime, mixinFunctions, mixinShipment],
  data () {
    return {
      selectedShipment: { fiataStatus: [], orderNumber: '' }
    }
  },
  methods: {
    feedBack (data) {
      this.$eventHub.$emit('dialog-rate-us', data.shipmentId)
    },
    feedBackView (data) {
      this.$eventHub.$emit('dialog-rate-us-second', data.shipmentId)
    },
    openModalDownloadFbl (data) {
      this.selectedShipment = data
      this.$bvModal.show('modalDownloadFbl')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/managementShipment/List.vue